import { useQuery } from '@tanstack/react-query';
import { GetListUserEntity, UserWalletManageService } from 'services/openapi';

import { UserServiceQueryKeys } from '../constants';

type GetListUserDTO = {
  searchString?: string;
  page: string;
  pageSize: string;
  isActive?: boolean;
  isDeleted?: boolean;
  role?: Parameters<
    typeof UserWalletManageService.userManageControllerGetListUser
  >[4];
  objectType?: Parameters<
    typeof UserWalletManageService.userManageControllerGetListUser
  >[5];
  leader?: string;
  compId?: string;
  searchDetailContent?: string;
};

export const useGetUsersListExportQuery = (variables: GetListUserDTO) => {
  const queryKey = [UserServiceQueryKeys.GET_USERS_LIST, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetListUserEntity, Error>({
    queryKey: ['export', ...queryKey],
    queryFn: () =>
      UserWalletManageService.userManageControllerGetListUser(
        variables.searchString,
        variables.page,
        variables.pageSize,
        variables.isActive,
        variables.role,
        variables.objectType,
        // variables.leader,
        variables.searchDetailContent,
        variables.compId,
        variables.isDeleted,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: false,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey: ['export', ...queryKey],
    refetch,
  };
};
